<template>
	<div>
		<div class="flex flex--justify-content-between flex--align-items-end mb-14-c">
			<div>
				<ReportsNav />
			</div>
		</div>

		<div class="row text-right mb-2">
			<div v-if="accountLevel == 'ib' || accountLevel == 'fm' || accountLevel == 'ccp'" class="col-auto text-left">
				<FilterClient class="d-inline-block" filterId="accountBalanceHistory"
					@changeFilterClient="changeFilterClientAccountBalanceHistory" :clients_prop="listClients">
				</FilterClient>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-header">
						<!-- <h5 v-if="selectedClientAccountBalanceHistory != 'all'">CURRENT BALANCES ({{selectedClientAccountBalanceHistory.hin_abx}} - {{selectedClientAccountBalanceHistory.personal_data[0].full_name}})</h5>
								<h5 v-else> CURRENT BALANCES (ALL) </h5> -->
						<h5> CURRENT BALANCES (ALL) </h5>

						<div class="row">
							<div class="col-sm-12 col-md-4 text-left">
								<dl class="row text-left">
									<dt class="col-7">Available Trade Balance</dt>
									<dd class="col-5">: {{ currencySymbol }}
										{{ numberFormatExtend(Number(availableTradeBalance).toFixed(2)) }}</dd>

									<dt class="col-7">Account Balance</dt>
									<dd class="col-5">: {{ currencySymbol }} {{ numberFormatExtend((isNaN(accountBalance)) ? 0 :
										Number(accountBalance).toFixed(2)) }}</dd>

									<dt class="col-7">Reserved Balance</dt>
									<dd class="col-5">: {{ currencySymbol }} {{ numberFormatExtend(Number(reservedBalance).toFixed(2))
									}}
									</dd>
								</dl>
							</div>
							<div class="col-sm-12 col-md-4">
								<dl class="row text-left">
									<dt class="col-7">Credit Limit</dt>
									<dd class="col-5"> :
										<span v-if="accountBalanceHistoriesStatus == 'loading' || accountBalanceHistoriesStatus == 'idle'">
											&nbsp;&nbsp;<Loader size_prop="14px" borderSize_prop="1px"></Loader>
										</span>

										<span v-else-if="accountBalanceHistoriesStatus == 'success'">
											{{ currencySymbol }} {{ numberFormatExtend(currentBalance.creditLimit.toFixed(2)) }}
										</span>

										<span v-else-if="accountBalanceHistoriesStatus == 'error'" @click="setAccountBalanceHistory">
											ERROR <IconRefresh></IconRefresh>
										</span>
									</dd>

									<dt class="col-7">Available Credit</dt>
									<dd class="col-5"> :
										<span v-if="accountBalanceHistoriesStatus == 'loading' || accountBalanceHistoriesStatus == 'idle'">
											&nbsp;&nbsp;<Loader size_prop="14px" borderSize_prop="1px"></Loader>
										</span>

										<span v-else-if="accountBalanceHistoriesStatus == 'success'">
											{{ currencySymbol }} {{ numberFormatExtend(currentBalance.availableCredit.toFixed(2)) }}
										</span>

										<span v-else-if="accountBalanceHistoriesStatus == 'error'" @click="setAccountBalanceHistory">
											ERROR <IconRefresh></IconRefresh>
										</span>
									</dd>
								</dl>
							</div>

							<div class="col-sm-12 col-md-4">
								<dl class="row text-left">

									<dt class="col-7">Settlement Owning</dt>
									<dd class="col-5"> :
										<span v-if="accountBalanceHistoriesStatus == 'loading' || accountBalanceHistoriesStatus == 'idle'">
											&nbsp;&nbsp;<Loader size_prop="14px" borderSize_prop="1px"></Loader>
										</span>

										<span v-else-if="accountBalanceHistoriesStatus == 'success'">
											{{ currencySymbol }} {{ numberFormatExtend(currentBalance.settlementOwning.toFixed(2)) }}
										</span>

										<span v-else-if="accountBalanceHistoriesStatus == 'error'" @click="setAccountBalanceHistory">
											ERROR <IconRefresh></IconRefresh>
										</span>
									</dd>

								</dl>
							</div>
							
						</div>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-sm-12 col-md-4">
								<p class="lead"><small>Available Trade Balance = Account Balance - Reserved Balance + Credit
										Limit</small></p>
							</div>
							<div class="col-sm-12 col-md-4">
								<p class="lead"><small>Available Credit = Credit Limit - Settlement Owning - Credit Reserved for
										Trades</small></p>
							</div>
							<div class="col-sm-12 col-md-4">
								<p class="lead"><small>Reserved Balance = Total Limit Price + Execution Fee + Tax + {{
									$store.state.fxBuffer * 100 }}% Total Limit
										Price (FX Buffer) + Total Transactions On Process</small></p>
							</div>
						</div>

						<div class="row">
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<Pagination2 v-if="accountLevel == 'client' || accountLevel == 'lp'" :totalData_prop="totalAccountBalanceHistory"
					@changePage="setAccountBalanceHistory">
				</Pagination2>

				<Pagination2 v-else :totalData_prop="totalBankTransactions" @changePage="setListBankTransactions">
				</Pagination2>
			</div>
			<div class="col-12 table-responsive p-0">
				<table v-if="accountLevel == 'ib' || accountLevel == 'client' || accountLevel == 'lp'"
					class="table table--report text-nowrap">
					<thead style="background-color: #0f0f17">
						<tr class="text-center">
							<th>DATE</th>
							<th>EFFECTIVE ACCOUNT ID</th>
							<th>ACCOUNT</th>
							<th>TRANSACTION ID</th>
							<th>TRANSACTION</th>
							<th>AMOUNT</th>
							<!-- <th>ACCOUNT BALANCE</th> -->
						</tr>
					</thead>
					<tbody>
						<template v-if="accountBalanceHistoriesStatus != 'loading'">
							<tr v-for="accountBalanceHistory in accountBalanceHistories"
								v-bind:key="'accountBalanceHistory' + accountBalanceHistory.transactionId">
								<td class="text-center">{{ accountBalanceHistory.date }}</td>
								<td class="text-center">{{ accountBalanceHistory.effectiveAccountId }}</td>
								<td class="text-center">{{ accountBalanceHistory.account }}</td>
								<td class="text-center">{{ accountBalanceHistory.transactionId }}</td>
								<td class="text-center">{{ accountBalanceHistory.transaction }}</td>
								<td v-if="currency == 'usd'" class="text-right">{{ numberFormatExtend(accountBalanceHistory.amount) }}
								</td>
								<td v-else class="text-right">{{ numberFormatExtend(accountBalanceHistory.amountIdr) }}</td>
								<!-- <td class="text-right">{{numberFormatExtend(Decimal.mul(accountBalanceHistory.accountBalance, streamingRateSell).toFixed(2))}}</td> -->
							</tr>
							<tr v-if="accountBalanceHistories.length < 1">
								<td colspan="7" class="text-center">No data available in table</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="7">
									<Loader size_prop="10em"></Loader>
								</td>
							</tr>
						</template>
					</tbody>
					<tfoot>

					</tfoot>
				</table>

				<table v-else class="table table--report text-nowrap">
					<thead style="background-color: #0f0f17">
						<tr class="text-center">
							<th>DATE</th>
							<th>TRANSACTION ID</th>
							<th>DEBIT</th>
							<th>CREDIT</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="bankTransactions.length > 0">
							<tr v-for="(item, index) in bankTransactions" :key="index + 'bankTransactions'">
								<td class="text-center">{{ item.date }}</td>
								<td class="text-center">{{ item.transactionId }}</td>
								<td class="text-right">{{ item.debit }}</td>
								<td class="text-right">{{ item.credit }}</td>
							</tr>
						</template>

						<tr v-else-if="apiStatusGetBankTransactions == 'loading'">
							<td class="text-center" colspan="4">
								<Loader size_prop="10em"></Loader>
							</td>
						</tr>

						<tr v-else-if="apiStatusGetBankTransactions == 'error'">
							<td class="text-center" colspan="4">
								Failed to retrieve data
							</td>
						</tr>

						<tr v-else>
							<td class="text-center" colspan="4">
								No data
							</td>
						</tr>

					</tbody>
				</table>
			</div>
		</div>

	</div>
</template>

<script>
import axios, { abortController } from '@/api/axios.js'
import Decimal from 'decimal.js'

import ReportsNav from '@/components/reports/ReportsNav.vue'
import Pagination2 from '@/components/Pagination2.vue'

import Loader from '@/components/Loader.vue'
import IconRefresh from '@/components/icons/IconRefresh.vue'

export default {
	name: 'AccountBalance',

	components: {
		ReportsNav,
		Pagination2,

		Loader,
		IconRefresh
	},

	data() {
		return {
			listClients: [],
			currentBalance: {},

			totalAccountBalanceHistory: 1,
			cancelTokenApiGetAccountBalanceHistory: '',
			cancelTokenApiGetHinAccountBalanceHistory: '',

			totalBankTransactions: 1,

			accountBalanceHistories: [],
			accountBalanceHistoriesStatus: 'idle',

			bankTransactions: [],
			totalBankTransactions: 1,
			apiSkipGetBankTransactions: '0',
			apiStatusGetBankTransactions: 'loading',
			cancelTokenApiBankTransactions: '',
		}
	},

	computed: {
		currency() {
			return this.$store.state.currency
		},

		contractsTemp() {
			return this.$store.state.contracts
		},

		products() {
			return this.$store.getters.PRODUCTS
		},

		accountLevel() {
			return this.$store.getters.getAccountLevel
		},

		currencySymbol() {
			if (this.currency == 'idr') {
				return 'Rp '
			} else {
				return '$'
			}
		},

		streamingRate() {
			return this.$store.getters.getStreamingRate
		},

		availableTradeBalance() {
			if (!this.$store.state.balances) {
				return -1
			}

			if (this.currency == 'idr') {
				return this.$store.state.balances.availableTradeBalanceIdr
			} else {
				return this.$store.state.balances.availableTradeBalanceUsd
			}
		},
		accountBalance() {
			if (!this.$store.state.balances) {
				return -1
			}

			if (this.currency == 'idr') {
				return this.$store.state.balances.balanceIdr
			} else {
				return this.$store.state.balances.balanceUsd
			}
		},
		reservedBalance() {
			if (this.currency == 'idr') {
				return Decimal.mul(this.$store.state.reservedBalance, this.streamingRate.streamBuy).toDecimalPlaces(2).toNumber()
			} else {
				return this.$store.state.reservedBalance
			}
		},
	},

	watch: {
		currency() {
			if (this.accountLevel != 'client' && this.accountLevel != 'lp') {
				this.setListBankTransactions(this.apiSkipGetBankTransactions)
			}
		},


	},

	created() {
		const firstCall = setInterval(() => {
			if (this.products && this.contractsTemp && this.accountLevel) {
				clearInterval(firstCall)

				this.setAccountBalanceHistory()
			}
		}, 1000)

	},

	mounted() {
	},

	methods: {
		changeFilterClientAccountBalanceHistory(clientData) {
			this.selectedClientAccountBalanceHistory = clientData
			if (this.accountLevel == 'ib' || this.accountLevel == 'fm') {
				this.setListBankTransactions()
			} else {
				this.setAccountBalanceHistory()
			}
		},

		setAccountBalanceHistory(skip = 0, limit = 10) {
			let urlApi = ''
			let hin = ''
			if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') {
				if (this.selectedClientAccountBalanceHistory == 'all') {
					urlApi = '/v2/rrs/specific/balance_history?offset=' + skip + '&limit=' + limit
				} else {
					urlApi = '/v2/rrs/specific/balance_history?hin=' + this.selectedClientAccountBalanceHistory.hin_abx + '&accountId=' + this.selectedClientAccountBalanceHistory.ac_abx
				}
			} else if (this.accountLevel == 'lp') {
				urlApi = '/v2/igx/market-maker/balance_history?offset=' + skip + '&limit=' + limit
				hin = this.$store.getters.getHin
			} else {
				urlApi = '/demo-abx/account/balanceHistory?marketplaceId=1&accountId=' + this.$store.state.demoAccountId + '&' + skip + '&limit=' + limit
				hin = this.$store.getters.getHin
			}

			if (this.cancelTokenApiGetAccountBalanceHistory) {
				//cancel api get account balance history
				this.cancelTokenApiGetAccountBalanceHistory.controller.abort()
			}
			this.cancelTokenApiGetAccountBalanceHistory = abortController()

			this.accountBalanceHistoriesStatus = 'loading'

			axios.get(urlApi, {
				signal: this.cancelTokenApiGetAccountBalanceHistory.signal
			}).then(response => {
				this.accountBalanceHistories = []
				this.currentBalance = {
					availableTradeBalance: 0,
					accountBalance: 0,
					reservedBalance: 0,
					creditLimit: 0,
					availableCredit: 0,
					settlementOwning: 0
				}

				this.totalAccountBalanceHistory = response.data.data.meta.count

				let balanceHistories = response.data.data.data

				if (balanceHistories.length < 1) {
					this.accountBalanceHistoriesStatus = 'success'
				}

				let indexAccountBalanceHistory = 0

				balanceHistories.forEach((balanceHistory) => {
					let dateTemp = new Date(balanceHistory.attributes.createdAt)
					let date = {
						year: dateTemp.getFullYear(),
						month: (dateTemp.getMonth() + 1 < 10) ? `0${dateTemp.getMonth() + 1}` : dateTemp.getMonth() + 1,
						date: (dateTemp.getDate() < 10) ? `0${dateTemp.getDate()}` : dateTemp.getDate(),
						hours: (dateTemp.getHours() < 10) ? `0${dateTemp.getHours()}` : dateTemp.getHours(),
						minutes: (dateTemp.getMinutes() < 10) ? `0${dateTemp.getMinutes()}` : dateTemp.getMinutes()
					}

					//
					if (this.accountLevel != 'ib' && this.accountLevel != 'fm') {
						if (balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash deposit' || balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash withdrawal') {
							return
						}
					} else if ((balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash deposit' && balanceHistory.attributes.amount <= 0) || (balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash withdrawal' && balanceHistory.attributes.amount >= 0)) {
						return
					}

					const rate = balanceHistory.attributes.rate || this.streamingRate.streamSell

					this.$set(this.accountBalanceHistories, indexAccountBalanceHistory, {
						date: `${date.year}/${date.month}/${date.date} ${date.hours}:${date.minutes}`,
						effectiveAccountId: response.data.data.hin || hin || '-',
						account: this.$store.getters.getFirstName || '-',
						transactionId: balanceHistory.id,
						transaction: balanceHistory.attributes.transactionTypeId,
						amount: balanceHistory.attributes.amount,
						amountIdr: Decimal.mul(balanceHistory.attributes.amount, rate).toNumber(),
						accountBalance: balanceHistory.attributes.total
					})

					indexAccountBalanceHistory++

				})

				let creditLimit = 0
				let settlementOwning = 0
				let availableCredit = this.currentBalance.creditLimit - this.currentBalance.settlementOwning

				this.currentBalance.creditLimit = Decimal.mul(creditLimit, this.streamingRate.streamBuy).toDecimalPlaces(2).toNumber()
				this.currentBalance.settlementOwning = Decimal.mul(settlementOwning, this.streamingRate.streamBuy).toDecimalPlaces(2).toNumber()
				this.currentBalance.availableCredit = Decimal.mul(availableCredit, this.streamingRate.streamBuy).toDecimalPlaces(2).toNumber()
				this.currentBalance.creditLimit = creditLimit
				this.currentBalance.settlementOwning = settlementOwning
				this.currentBalance.availableCredit = availableCredit

				this.accountBalanceHistoriesStatus = 'success'
				console.log('berhasil balance history', response)
			}).catch(error => {
				this.accountBalanceHistoriesStatus = 'error'
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('gagal balance history', error.config)
			})
		},

		setListBankTransactions(skip = 0, limit = 10) {
			this.apiSkipGetBankTransactions = skip
			this.bankTransactions = []

			let param = ''
			if (this.accountLevel == 'ib') {
				if (this.selectedClientAccountBalanceHistory == 'all') {
					param = '/v2/bank-transaction/ib?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx='
				} else {
					param = '/v2/bank-transaction/ib?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx=' + this.selectedClientAccountBalanceHistory.ac_abx
				}
			} else {
				// get selected account level
				let temp = this.selectedClientAccountBalanceHistory.hin_abx
				let selectedAccountLevel = ''
				const template = { IB: 'ib', PB: 'fm', LP: 'lp', PC: 'client' }
				if (temp) {
					selectedAccountLevel = template[temp.substr(0, 2)]
				} else {
					selectedAccountLevel = '-'
				}

				if (this.selectedClientAccountBalanceHistory == 'all') {
					param = '/v2/bank-transaction/pb?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx=&sponsor_id_abx='
				} else if (selectedAccountLevel == 'ib') {
					param = '/v2/bank-transaction/pb?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx=&sponsor_id_abx=' + this.selectedClientAccountBalanceHistory.sponsor_id_abx
				} else {
					param = '/v2/bank-transaction/pb?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx=' + this.selectedClientAccountBalanceHistory.ac_abx + '&sponsor_id_abx=' + this.selectedClientAccountBalanceHistory.sponsor_id_abx
				}
			}

			this.apiStatusGetBankTransactions = 'loading'
			if (this.cancelTokenApiBankTransactions) {
				this.cancelTokenApiBankTransactions.controller.abort
			}
			this.cancelTokenApiBankTransactions = abortController()

			axios.post(param, {
				user_id: this.$store.state.userId
			}, {
				signal: this.cancelTokenApiBankTransactions.signal,
			}).then(response => {

				this.totalBankTransactions = response.data.total

				let streamingRate = 1
				if (this.currency == 'usd') {
					streamingRate = this.streamingRate.streamSell
				}

				let history = response.data.data
				for (let i = 0; i < 10; i++) {
					let dateTemp = new Date(history[i].created_at)
					let date = {
						year: dateTemp.getFullYear(),
						month: (dateTemp.getMonth() + 1 < 10) ? `0${dateTemp.getMonth() + 1}` : dateTemp.getMonth() + 1,
						date: (dateTemp.getDate() < 10) ? `0${dateTemp.getDate()}` : dateTemp.getDate(),
						hours: (dateTemp.getHours() < 10) ? `0${dateTemp.getHours()}` : dateTemp.getHours(),
						minutes: (dateTemp.getMinutes() < 10) ? `0${dateTemp.getMinutes()}` : dateTemp.getMinutes()
					}

					let indexOfStart = history[i].reff_transaction.indexOf("-")
					let transactionId = history[i].reff_transaction.substring(indexOfStart + 1)

					let debit = history[i].type == 'debit' ? this.numberFormatExtend(Decimal.mul(history[i].amount, -1).dividedBy(streamingRate).toFixed(2)) : '-'
					let credit = history[i].type == 'credit' ? this.numberFormatExtend(Decimal.div(history[i].amount, streamingRate).toFixed(2)) : '-'

					this.bankTransactions.push({
						date: `${date.year}/${date.month}/${date.date} ${date.hours}:${date.minutes}`,
						transactionId: transactionId,
						debit: debit,
						credit: credit
					})
				}

				this.apiStatusGetBankTransactions = 'success'
				console.log('berhasil get list bank transactions', response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}

				this.apiStatusGetBankTransactions = 'error'
				console.log('gagal get list bank transactions', error.config)
			})
		},
	}
}
</script>

<style scoped>
.c-row-table:hover {
	background-color: rgb(0, 0, 0, 0.3);
	cursor: pointer;
}

.title-c {
	font-size: 1.625rem;
	color: white;
}
</style>